import * as commonScripts from '../common'
import { TimelineLite, CSSPlugin } from 'gsap/all'
import 'whatwg-fetch'

// gsap.registerPlugin(CSSPlugin)
const plugins = [CSSPlugin]

const cmpFeaturedPerspectivesCard = {    
    component: null,
  apiEndpoint: null,
  currentPageId: null,
  resultsDiv: null,
  loadMore: null,
  loadMoreBtn: null,
  query: {},

  init: function (element) {
    const _ = this
    _.component = element

    commonScripts.util.inheritPermalink(element)
    
    _.apiEndpoint = element.getAttribute('data-api-endpoint')  
    _.currentPageId = element.getAttribute('data-currentPage-id')  
    _.resultsDiv = _.component.querySelector('.cmp-perspectives-list__results')
    _.loadMoreBtn = _.component.querySelector('.btn-load-more-cta')  

    if (_.loadMoreBtn != null) {
      _.loadMoreBtn.addEventListener('click', (e) => {
        e.preventDefault()
        _.loadMoreBtn.classList.add('disabled')
        const prevPage = _.loadMoreBtn.getAttribute('data-page') * 1
        
        _.loadMore = true
        _.buildQuery()
        _.loadMoreBtn.setAttribute('data-page', prevPage + 1)
      })
    }    
  },
  
  buildQuery: function () {
    const _ = this
    let queryString
    _.query = {}

    _.query.lang = document.documentElement.lang
    if (_.loadMore) {
      const page = _.loadMoreBtn.getAttribute('data-page')
      _.query.page = page
    } else {
      if (_.loadMoreBtn != null) {
        _.loadMoreBtn.setAttribute('data-page', 1)
      }
      _.query.page = 0
    }
    _.query.pageId = _.currentPageId

    this.query.lang = document.documentElement.lang  
      
    queryString = Object.keys(_.query).map((key) => {
        return key + '=' + encodeURIComponent(_.query[key])
      }).join('&')
    _.fetchResults(queryString)
  },

  fetchResults: function (queryString) {
    const _ = this
    const fetchOpts = {
      method: 'GET',
      headers: {}
    }

    let url = ''
    if (queryString.length > 0)
    {
      if(!queryString.includes('lang='))
      {
        queryString = 'lang=' + document.documentElement.lang + '&'+ queryString
      }
      url = _.apiEndpoint + '?' + queryString
    } 
    else {
      url = _.apiEndpoint
    }
    window.fetch(url, fetchOpts)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return response.text()
      }).then((body) => {
        _.processResponse(body)
      }).catch((err) => {
        console.log('Request Failed', err)
      })
  },

  processResponse: function (body) {
    const _ = this
    const cards = _.resultsDiv.querySelectorAll('.cmp-viewpoint-cards__card')
    const stagingDiv = document.createElement('div')
    stagingDiv.classList.add('staging-zone')
    stagingDiv.classList.add('bg-white')
    stagingDiv.insertAdjacentHTML('beforeend', body)
    commonScripts.util.inheritPermalink(stagingDiv)

    if (_.loadMore) {
      _.resultsDiv.appendChild(stagingDiv)
      const newCards = _.resultsDiv.querySelectorAll('.cmp-viewpoint-cards__card')
      _.showCards(newCards)
      _.showHideMoreBtn()
    } else {
      const tl = new TimelineLite()
      tl.to(cards, { scale: 0.5, opacity: 0, duration: 0.5 })
      tl.eventCallback('onComplete', () => {
        _.resultsDiv.innerHTML = ''
        _.resultsDiv.appendChild(stagingDiv)
        const newCards = _.resultsDiv.querySelectorAll('.cmp-viewpoint-cards__card')
        _.showCards(newCards)
        _.showHideMoreBtn()
      })
    }

    _.loadMoreBtn.classList.remove('disabled')
    _.loadMoreBtn.blur()
  },

  showCards: function (cards) {
    if (cards) {
      const tl = new TimelineLite()
      tl.to(cards, { scale: 1, opacity: 1, duration: 0.5 })
    }
  },

  showHideMoreBtn: function () {
    const _ = this
    if (_.resultsDiv.querySelector('.no-results')) {
      _.loadMoreBtn.classList.add('d-none')
    } else {
      _.loadMoreBtn.classList.remove('d-none')
    }
  },

  
}

export default cmpFeaturedPerspectivesCard